/* eslint-disable no-unused-vars */
import React, { useState, useContext } from 'react';
import SelectedCarModel from './SelectedCarModel';
import TimeAndDelivery from './TimeAndDelivery';
import MaterialSelect from './utils/MaterialSelect';
import ContactModal from './modal/ContactModal';
import useCarsData from '../hooks/useCarsData';
import useRentTimeData from '../hooks/useRentTimeData';
import useContactUrl from '../hooks/useContactUrl';
import useTotalData from '../hooks/useTotalData';
import { getPdfShare } from './utils/getPdfShare';

const TimeAndModel = () => {

    const { setSelectedCar, getSelectedCar } = useCarsData();
    const { unit_options, unit, amount, setUnit, setAmount } = useRentTimeData();
    const { contact_url } = useContactUrl();
    const { getCarTotal } = useTotalData();
    const [showContactModal, setShowContactModal] = useState(false);
    const selectedCar = getSelectedCar();

    const handleCarSelect = car => {
        setSelectedCar(car.id);

        // SEO google dataLayer
        dataLayer.push({
            'event': 'trackEvent',
            'eventCategory': 'cotizar_share',
            'eventAction': 'elegir_modelo',
            'eventLabel': car.name
        });
    }

    const handleUnitChange = (e) => {
        const selectedUnit = e.target.value;
        setUnit(selectedUnit);
        if (selectedUnit === 'horas' && amount > 24) {
            setAmount(24);
        }

        // SEO google dataLayer
        window.dataLayer.push({
            'event': 'trackEvent',
            'eventCategory': 'cotizar_share',
            'eventAction': 'tiempo',
            'eventLabel': `${selectedUnit} - ${amount}`
        });
    }
    
    const handleAmountChange = (e) => {
        let newAmount = parseInt(e.target.value);
        
        if (isNaN(newAmount)) newAmount = 0;
        
        if (newAmount <  0) newAmount = 0;
        if (newAmount > 24 && unit === 'horas') newAmount = 24;
        if (newAmount > 90 && unit === 'dias') newAmount = 90;
        
        setAmount(newAmount);

        // SEO google dataLayer
        window.dataLayer.push({
            'event': 'trackEvent',
            'eventCategory': 'cotizar_share',
            'eventAction': 'tiempo',
            'eventLabel': `${unit} - ${newAmount}`
        });
    }

    const calculateTotal = () => {
        if (!selectedCar || !amount) return '$XX.XXX';
        
        const total = getCarTotal();
        
        return new Intl.NumberFormat('es-CL', {
            style: 'currency',
            currency: 'CLP',
            minimumFractionDigits: 0
        }).format(total);
    }

    const toggleContactModal = () => {
        setShowContactModal(!showContactModal);

        // SEO google dataLayer
        window.dataLayer.push({
            'event': 'trackEvent',
            'eventCategory': 'cotizar_share',
            'eventAction': 'cta',
            'eventLabel': 'contactar_comercial'
        });
    };

    const handleContactClick = () => {
        // SEO google dataLayer
        window.dataLayer.push({
            'event': 'trackEvent',
            'eventCategory': 'cotizar_share',
            'eventAction': 'cta',
            'eventLabel': 'contactar_comercial'
        });
        console.log(window.dataLayer)
    };

    const handleDownloadQuote = async () => {
        if (selectedCar && amount > 0) {
            try {
                const response = await getPdfShare({
                    car: selectedCar.id,
                    unit,
                    amount,
                    car_subtotal: getCarTotal(),
                    img: selectedCar.photo_1.url,
                });

                const file = new Blob([response.data], { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(file);
                const link = document.createElement('a');
                const safeName = selectedCar.name.toLowerCase().replace(/\s+/g, '-');
                link.href = fileURL;
                link.download = `cotizacion-kinto-share-${safeName}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(fileURL);
            } catch (error) {
                console.error('Error al descargar PDF de Kinto Share', error);
            }

            // SEO google dataLayer
            window.dataLayer.push({
                'event': 'trackEvent',
                'eventCategory': 'cotizar_share',
                'eventAction': 'cta',
                'eventLabel': 'imprimir_detalle'
            });
        }
    };

    return (
        <section className="time-and-model">
            <div className="time-and-model-content">
                <div className="quoter-header no-print">
                    <h2>Cotiza tu plan KINTO SHARE</h2>
                    <p>Define el tiempo y el modelo para conocer el costo estimado de tu uso</p>
                </div>

                <div className="quoter-form">
                    <div className="form-row-group">
                        <div className="form-row">
                            <label>Modelo</label>
                            <MaterialSelect onCarSelect={handleCarSelect} defaultText="Selecciona tu Toyota"/>
                        </div>
                        <div className="form-row model-preview">
                            {selectedCar ? (
                                <div className="model-preview-content">
                                    <img src={selectedCar.photo_1.url} alt={selectedCar.name} />
                                </div>
                            ) : (
                                <div className="model-preview-placeholder">
                                    <p>Selecciona un modelo</p>
                                </div>
                            )}
                        </div>
                    </div>
                    

                    <div className="form-row-group">
                        <div className="form-row">
                            <label>Duración</label>
                            <select className="form-control" onChange={handleUnitChange} value={unit}>
                                {unit_options.map(item => (
                                    <option key={item.value} value={item.value}>{item.label}</option>
                                ))}
                            </select>
                        </div>

                        <div className="form-row">
                            <label>{unit === 'dias' ? 'Días' : 'Horas'}</label>
                            <input 
                                type="number" 
                                className="form-control" 
                                onChange={handleAmountChange} 
                                value={amount || ''}
                                placeholder="0"
                                min="0"
                                max={unit === 'horas' ? '24' : '90'}
                            />
                        </div>
                    </div>
                </div>

                <div className="quoter-result">
                    <div className="result-label">Total estimado:</div>
                    <div className="result-price">{calculateTotal()} </div>
                    <div className="result-note">Incluye seguro y asistencia KINTO</div>
                </div>

                <div className="quoter-actions no-print">
                    <button 
                        className="button --new --light"
                        onClick={handleDownloadQuote}>
                        DESCARGAR DETALLE DE COTIZACIÓN
                    </button>
                    {contact_url != 'None' ? (
                        <a
                            href={contact_url}
                            target='_blank'
                            rel='noopener noreferrer'
                            className='button --new --dark'
                            onClick={handleContactClick}>
                            CONTACTAR UN ASESOR
                        </a>
                    ) : (
                        <button 
                            className="button --new --dark"
                            onClick={toggleContactModal}>
                            CONTACTAR UN ASESOR
                        </button>
                    )}
                </div>

                <div className="instructions-section no-print">
                    <div className="instructions-text">
                        <h3>¿Cómo reservar tu KINTO?</h3>
                        <ol>
                            <li>
                                <p>Descarga la App KINTO Share Chile.</p>
                            </li>
                            <li>
                                <p>Regístrate con tu licencia y tarjeta.</p>
                            </li>
                            <li>
                                <p>Recibe un mail de confirmación.</p>
                            </li>
                            <li>
                                <p>Elige estación, horario y tu modelo favorito</p>
                            </li>
                        </ol>
                    </div>
                </div>

                <div className="no-print" style={{ display: 'none' }}>
                    <SelectedCarModel />
                </div>
            </div>

            {showContactModal && <ContactModal onClose={toggleContactModal} />}
        </section>
    );
}

export default TimeAndModel;
